import React, { Fragment, useState } from "react";
import Breadcrumb from "../../../../../layout/breadcrumb";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import BulkInvoiceWalletClaim from "./bulk-invoice-wallet-claim";
import BulkInvoiceWalletPending from "./bulk-invoice-wallet-pending";
import { Nav, NavItem, NavLink, TabContent, TabPane, Card } from 'reactstrap';

const BulkInvoiceWallet = () => {
  const [viewPolicyDetailsByType, setViewPolicyDetailsByType] = useState(0);

  const steps = [
    { key: 0, name: 'Pending for payment', component: <BulkInvoiceWalletPending /> },
    { key: 1, name: 'Pending for claim', component: <BulkInvoiceWalletClaim /> },
  ];

  return (
    <Fragment>
      <Breadcrumb parent="Sales" title="Bulk Invoice Wallet" />
      <Card style={{ padding: "5px" }}>
        <div style={{ width: "50%", display: "flex", alignItems: "center" }}>
          <Nav className="nav-pills nav-justified">
            {steps && steps.map((item, i) => {
              return (
                <NavItem key={i}>
                  <NavLink
                    href="#javascript"
                    className={viewPolicyDetailsByType === item.key ? 'active' : ''}
                    onClick={() => setViewPolicyDetailsByType(item.key)}
                  >
                    <span style={{ whiteSpace: 'nowrap' }}>{item.name}</span>
                  </NavLink>
                </NavItem>
              );
            })}
          </Nav>
        </div>

        <TabContent activeTab={viewPolicyDetailsByType} style={{ padding: "10px" }}>
          {steps && steps.map((item, i) => {
            return (
              <TabPane className={item.key === 0 ? "fade show" : ""} tabId={item.key} key={i}>
                {item.component}
              </TabPane>
            );
          })}
        </TabContent>
      </Card>
    </Fragment>
  );
};

const BulkInvoiceWalletWithLocalizationProvider = () => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <BulkInvoiceWallet />
  </LocalizationProvider>
);

export default BulkInvoiceWalletWithLocalizationProvider;
